export async function affShipmentsPrepareUseCase(orders, shipmentRepository) {

    const result = await shipmentRepository.aff_prepare_orders(orders);
    
    const entity = new shipmentRepository.model_aff_prepare(result.data);

    if (!entity.isValid()) {
        console.log(entity)
        throw new Error(" Shipments Aff Prepare Inválido");
    }
    
    return result;
}